export default __webpack_public_path__ + "slices/main/assets/public/media/community-carousel-slide-1.67cd5d37bf72b3b09e9c6c9f8828685b.png";